
import {
  GET_CHART_OF_ACCOUNT_REPORT_REQUEST,
  GET_CHART_OF_ACCOUNT_REPORT_SUCCESS,
  GET_CHART_OF_ACCOUNT_REPORT_ERROR
} from "../actions/types";

export const ChartOfAccount = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CHART_OF_ACCOUNT_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_CHART_OF_ACCOUNT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_CHART_OF_ACCOUNT_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};